export type TopicProps = {
  displayText: string;
  url?: string;
};
